"use client";

import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

type SkillCheckAnimationStore = {
  animationCount: number;
  incrementAnimationCount: () => void;
};

const SkillCheckAnimationContext =
  createContext<SkillCheckAnimationStore | null>(null);

export function useSkillCheckAnimation(): SkillCheckAnimationStore {
  const ctx = useContext(SkillCheckAnimationContext);
  if (!ctx) {
    throw new Error(
      "useSkillCheckAnimation must be used within SkillCheckAnimationProvider"
    );
  }
  return ctx;
}

export function SkillCheckAnimationProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [animationCount, setAnimationCount] = useState(0);
  const incrementAnimationCount = useCallback(() => {
    setAnimationCount((prev) => prev + 1);
  }, []);
  const value = useMemo(
    () => ({ animationCount, incrementAnimationCount }),
    [animationCount, incrementAnimationCount]
  );
  return (
    <SkillCheckAnimationContext.Provider value={value}>
      {children}
    </SkillCheckAnimationContext.Provider>
  );
}
